export function isCEP(cep: string): boolean {
  const CEP: string = `${cep}`.replace(/[^\d]+/g, '');
  return !!(CEP && CEP.length === 8);
}
